
import EoImg from '../EoImg/EoImg.vue'

export default {
  name: 'EoCarouselItem',
  components: { EoImg },
  props: {
    /**
     * URL to download of item
     */
    downloadUrl: {
      type: String,
      default: null,
    },
    /**
     * Name of the item
     */
    name: {
      type: String,
      default: null,
    },
    /**
     * File type of the item
     */
    extension: {
      type: String,
      default: null,
    },
    /**
     * URL to thumnail of item
     */
    thumbnail: {
      type: String,
      default: null,
    },
    /**
     * Caption underneath the photo
     */
    caption: {
      type: String,
      default: null,
    },
    /**
     * Type of the item (image, video)
     */
    type: {
      type: String,
      default: null,
    },
    /**
     * Enables image contain mode for images with different aspect ratio
     */
    respectRatio: Boolean,
    /**
     * Media is portrait
     */
    portrait: Boolean,
    /**
     * See <eo-img> prop 'size'
     */
    imageSize: {
      type: [String, Number],
      default: null,
    },
    /**
     * See <eo-img> prop 'width'
     */
    imageWidth: {
      type: [String, Number],
      default: null,
    },
    /**
     * See <eo-img> prop 'focus'
     */
    imageFocus: {
      type: [String, Object],
      default: null,
    },
  },
  data () {
    return {
      isActive: false,
      transitionName: null,
    }
  },
  computed: {
    transition () {
      if (this.$parent.transition === "fade") {
        return "fade"
      } else {
        return this.transitionName
      }
    },
  },
  created () {
    this.$parent.carouselItems.push(this)
  },
  beforeDestroy () {
    const index = this.$parent.carouselItems.indexOf(this)
    if (index >= 0) {
      this.$parent.carouselItems.splice(index, 1)
    }
  },
  methods: {
    /**
     * Status of item, alter animation name based on action.
     */
    status (value, action) {
      this.transitionName = action ? "slide-next" : "slide-prev"
      this.isActive = value
    },
    /**
     * Check how much of a video is visible on screen and play or pause based on that
     */
    async onVideoInViewport (ratio, vnode) {
      const el = vnode.elm || vnode.$el
      if (!el) return
      if (ratio <= 0) {
        el.pause()
      } else if (el.paused) {
        el.play()
      }
    },
  },
}
